import React from "react";
import appConfig from "@/config/app-config";

type ContextValue = {
  getSession: (sessionId: string) => Promise<Response>;
};

export const ApiContext = React.createContext<ContextValue | undefined>(
  undefined,
);

export const ApiProvider = ({ children }: React.PropsWithChildren) => {
  const getSession = (sessionId: string) => {
    return fetch(`${appConfig.apiBase}/auth/login/webreg/${sessionId}`, {
      method: "GET",
    });
  };

  const value = {
    getSession,
  };

  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
};
